import {FaPizzaSlice, FaHamburger} from 'react-icons/fa';
import {GiNoodles, GiChopsticks, GiTacos} from 'react-icons/gi';
import {MdOutlineDinnerDining} from 'react-icons/md';
import styled from "styled-components";
import { NavLink } from 'react-router-dom';

import React from 'react'

function Category() {
  return (
    <List>
      <CategoryLink to={'/cuisine/Italian'}>
        <IconWrapper>
          <FaPizzaSlice />
        </IconWrapper>
        <Label>Italian</Label>
      </CategoryLink>
      <CategoryLink to={'/cuisine/American'}>
        <IconWrapper>
          <FaHamburger />
        </IconWrapper>
        <Label>American</Label>
      </CategoryLink>
      <CategoryLink to={'/cuisine/Thai'}>
        <IconWrapper>
          <GiNoodles />
        </IconWrapper>
        <Label>Thai</Label>
      </CategoryLink>
      <CategoryLink to={'/cuisine/Japanese'}>
        <IconWrapper>
          <GiChopsticks />
        </IconWrapper>
        <Label>Japanese</Label>
      </CategoryLink>
      <CategoryLink to={'/cuisine/Mexican'}>
        <IconWrapper>
          <GiTacos />
        </IconWrapper>
        <Label>Mexican</Label>
      </CategoryLink>
      <CategoryLink to={'/cuisine/Chinese'}>
        <IconWrapper>
          <MdOutlineDinnerDining />
        </IconWrapper>
        <Label>Chinese</Label>
      </CategoryLink>
    </List>
  )
}

const List = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-xs);
  flex-wrap: wrap;

  @media screen and (max-width: 900px) {
    gap: 6px;
  }
`

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-secondary);
  transition: color var(--transition-fast);

  svg {
    font-size: 1.25rem;
    width: 1.25rem;
    height: 1.25rem;
  }
`

const Label = styled.span`
  font-size: 0.75rem;
  font-weight: var(--font-weight-medium);
  color: var(--color-text-primary);
  transition: color var(--transition-fast);
`

const CategoryLink = styled(NavLink)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  text-decoration: none;
  padding: var(--spacing-sm);
  border-radius: var(--radius-md);
  background: var(--color-surface-elevated);
  border: 1px solid var(--color-border-subtle);
  cursor: pointer;
  transition: all var(--transition-fast);
  width: 88px;
  height: 76px;

  &:hover {
    border-color: var(--color-border);
    background: var(--color-surface-elevated);

    ${IconWrapper} {
      color: var(--color-text-primary);
    }
  }

  &.active {
    background: var(--color-accent);
    border-color: var(--color-accent);

    ${IconWrapper} {
      color: white;
    }

    ${Label} {
      color: white;
    }
  }

  @media screen and (max-width: 900px) {
    width: 72px;
    height: 64px;
    padding: var(--spacing-xs);

    ${IconWrapper} svg {
      font-size: 1.125rem;
      width: 1.125rem;
      height: 1.125rem;
    }

    ${Label} {
      font-size: 0.6875rem;
    }
  }
`

export default Category
